export default __webpack_public_path__ + "images/c94b37bb2696574cbe29a2d164e378ec.svg";